// extracted by mini-css-extract-plugin
export default {"heading1":"heading1--Ud2EK"};